import React from 'react';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ViewCourseSessionRecord} from 'src/pages/Modules/Training/shared/ViewCourseSessionRecord/ViewCourseSessionRecord';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const AdminCourseSessionRecordPage: React.FC = () => {
  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Training}>
      <ViewCourseSessionRecord isAdminPath={true} />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.TrainingCourseSessionView(
    ':definitionId',
    ':assignmentId',
    ':sessionId',
    ':view'
  ),
  element: <AdminCourseSessionRecordPage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
